<template>
  <section class="help-tab">
    <div class="columnWrapper">
      <div class="videoWrapper">
        <h1 class="h1">See how to setup your Wellcome platform</h1>
      </div>
      <div class="contactWrapper">
        <div class="h4 contactItem">Har du brug for hjælp?</div>
        <div class="h4 contactItem">
          <span style="margin-right: 1rem">Så ring til os på:</span>
          <a href="tel:+4560534616">+45 53 64 88 62</a>
        </div>
        <div class="h4 contactItem">
          <span style="margin-right: 1rem">eller send en mail: </span>
          <a href="mailto:info@easyguest.dk">lei@easyguest.dk</a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  methods: {
    editorImgButton: function () {
      this.isModalVisible = true;
    },
    toggleLanguage(indexClicked) {
      this.languageTypesIndex = indexClicked;
    },
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.columnWrapper {
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
}

.videoWrapper {
  margin-right: auto;
  flex-direction: column;
}

.iframe-wrapper {
  height: 450px;
  background: #222;
}

h2 {
  margin-top: 48px;
}

p {
  color: inherit;
  font: inherit;
  font-size: inherit;
}

a {
  color: inherit;
  font: inherit;
  text-decoration: none;
}

a:hover {
  cursor: pointer;
}

.h4 {
  display: flex;
  align-items: center;
  margin-top: 24px;
}
</style>
